import { createContext, useContext } from 'react';

const ComponentRootRef = /*#__PURE__*/createContext({
  current: null
});
function useComponentRootRef() {
  return useContext(ComponentRootRef);
}
const PageContext = /*#__PURE__*/createContext("input");
function usePageContext() {
  return useContext(PageContext);
}

export { ComponentRootRef, PageContext, useComponentRootRef, usePageContext };
//# sourceMappingURL=context.js.map
